import { render, staticRenderFns } from "./synchronization.vue?vue&type=template&id=0618dddc&scoped=true&"
import script from "./synchronization.vue?vue&type=script&lang=js&"
export * from "./synchronization.vue?vue&type=script&lang=js&"
import style0 from "./synchronization.vue?vue&type=style&index=0&id=0618dddc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0618dddc",
  null
  
)

export default component.exports